import { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { Select, MenuItem } from "@mui/material";

import tw from "tailwind-styled-components";
import { CombineInputGroup, FieldWrappers, Label } from "../Styles/InputStyle2";
const FilterSection = () => {
    const [activeFilters, setActiveFilters] = useState({});
    const [filtersApplied, setFiltersApplied] = useState(false);

    const statusOptions = [
        { label: "A", value: 1 },
        { label: "B", value: 2 },
        { label: "C", value: 3 },
    ];

    const categoryOptions = [
        { label: "A", value: 1 },
        { label: "B", value: 2 },
        { label: "C", value: 3 },
        { label: "D", value: 4 },
    ];
   
    const staffRole = [
        { label: "Partner", value: "Partner" },
        { label: "Carpenter", value: "Carpenter" },
        { label: "Laundry", value: "Laundry" },
        { label: "Plumber", value: "Plumber" },
        { label: "Electrician ", value: "Electrician" },
    ];

    const handleSubmit = (values) => {
        const appliedFilters = Object.fromEntries(
            Object.entries(values).filter(([_, value]) => value !== "")
        );
        setActiveFilters(appliedFilters);
        setFiltersApplied(Object.keys(appliedFilters)?.length > 0);
        console.log("Applied Filters:", appliedFilters);
    };

    const handleReset = (resetForm) => {
        resetForm();
        setActiveFilters({});
        setFiltersApplied(false);
    };

    return (

        <>
            <Container>
                <Formik
                    initialValues={{
                        status: "",
                        category: "",
                        role: "",
                        staffname: "",
                    }}
                    onSubmit={handleSubmit}
                >
                    {({ values, resetForm, isSubmitting, setFieldValue }) => (
                        <Form>
                            <div className="flex flex-wrap gap-4 mt-8">
                                <CombineInputGroup>
                                    <InputGroup>
                                        <Label htmlFor="category">Category</Label>
                                        <FieldWrapper>
                                            <Select
                                                id="category"
                                                name="category"
                                                className="w-full pl-2"
                                                value={values.category}
                                                onChange={(e) => {
                                                    setFieldValue("category", e.target.value);
                                                }}
                                            >
                                                <MenuItem value="">Select Category</MenuItem>
                                                {categoryOptions.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                        </FieldWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="status">Status</Label>
                                        <FieldWrapper>
                                            <Select
                                                id="status"
                                                name="status"
                                                className="w-full pl-2"
                                                value={values.status}
                                                onChange={(e) => {
                                                    setFieldValue("status", e.target.value);
                                                }}
                                            >
                                                <MenuItem value="">Select Status</MenuItem>
                                                {statusOptions.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                        </FieldWrapper>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="role">Role</Label>
                                        <FieldWrapper>
                                            <Select
                                                id="role"
                                                name="role"
                                                className="w-full pl-2"
                                                value={values.role}
                                                onChange={(e) => {
                                                    setFieldValue("role", e.target.value);
                                                }}
                                            >
                                                <MenuItem value="">Select Role</MenuItem>
                                                {staffRole.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                        </FieldWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>Staff Name</Label>
                                        <FieldWrappers className="rounded">
                                            <search
                                                className="text-gray-400 mr-1"
                                                style={{ fontSize: 18 }}
                                            />
                                            <Field name="staffname" as={Input} placeholder="Search" />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <div className="flex items-end sm:mt-7 gap-4">
                                        <AddBtn type="submit">
                                            Apply Filter
                                        </AddBtn>
                                    </div>
                                </CombineInputGroup>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Container>
        </>
    );

};
const Container = tw.div`w-full max-w-6xl mx-auto`;

const Input = tw.input`outline-none text-sm w-full`;
const AddBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const ResetBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-primary-color h-full rounded-md px-3 cursor-pointer bg-gray-100 py-2.5 text-sm`;
const InputGroup = tw.div`w-full flex flex-col space-y-1.5`;
const FieldWrapper = tw.div`w-full`;
export default FilterSection;